// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2t2FS","title":"AfterBackImages_title__1l8Oh","images":"AfterBackImages_images__US42A"};